import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "docfile" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "size" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FileIcon = _resolveComponent("FileIcon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FileIcon, {
      painted: "",
      "font-size": "0.9rem",
      ext: $props.file.ext,
      class: "icon"
    }, null, 8 /* PROPS */, ["ext"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($options.name), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, _toDisplayString($options.size), 1 /* TEXT */)
    ])
  ]))
}